import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-bank-details-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>Bank Details for {{ distributorName }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <div class="modal-body">
    <!-- List View -->
    <div *ngIf="viewMode === 'list'">
      <div *ngIf="loading" class="loading-state">
        <i class="fas fa-spinner fa-spin"></i> Loading bank details...
      </div>

      <div *ngIf="!loading && bankAccounts.length === 0" class="empty-state">
        <p>No bank accounts linked yet.</p>
      </div>

      <div *ngIf="!loading" class="cards-container">
        <div class="bank-card" *ngFor="let acc of bankAccounts">
          <div class="card-header">
            <h3>{{acc.bank_name}}</h3>
            <span class="primary-badge" *ngIf="acc.is_primary">Primary</span>
          </div>
          <div class="card-body">
            <p><strong>Merchant ID:</strong> {{acc.merchant_id || 'N/A'}}</p>
            <p><strong>A/c Name:</strong> {{acc.bank_account_name}}</p>
            <p><strong>A/c Number:</strong> {{acc.bank_account_number}}</p>
            <p><strong>Type:</strong> {{acc.bank_account_type}}</p>
            <p><strong>IFSC:</strong> {{acc.ifsc_code}}</p>
            <p *ngIf="acc.branch"><strong>Branch:</strong> {{acc.branch}}</p>
          </div>
          <div class="card-actions">
            <button class="btn small secondary" *ngIf="!acc.is_primary" (click)="setPrimary(acc.id)" [disabled]="isProcessing">Set as Primary</button>
            <button class="btn small danger" (click)="deleteAccount(acc.id)" [disabled]="isProcessing">Delete</button>
          </div>
        </div>
      </div>
      
      <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

      <div style="margin-top:20px;">
        <button class="btn primary full-width" (click)="viewMode = 'add'">+ Add New Bank Account</button>
      </div>
    </div>

    <!-- Add View -->
    <div *ngIf="viewMode === 'add'">
      <form (ngSubmit)="onSubmit()" #form="ngForm">
        <div class="grid">
          <div class="form-group full">
            <input type="text" [(ngModel)]="newBank.bank_account_name" name="bank_account_name" required placeholder=" " />
            <label>Account Name</label>
            <span class="error" *ngIf="fieldErrors['bank_account_name']">{{fieldErrors['bank_account_name']}}</span>
          </div>

          <div class="form-group">
            <input type="text" [(ngModel)]="newBank.bank_account_number" name="bank_account_number" required placeholder=" " />
            <label>Account Number</label>
            <span class="error" *ngIf="fieldErrors['bank_account_number']">{{fieldErrors['bank_account_number']}}</span>
          </div>

          <div class="form-group">
            <input type="text" [(ngModel)]="confirm_account_number" name="confirm_account_number" required placeholder=" " />
            <label>Confirm Account Number</label>
            <span class="error" *ngIf="fieldErrors['confirm_account_number']">{{fieldErrors['confirm_account_number']}}</span>
          </div>

          <div class="form-group">
            <select [(ngModel)]="newBank.bank_account_type" name="bank_account_type" required>
              <option value="Saving">Saving</option>
              <option value="Current">Current</option>
            </select>
            <label>Account Type</label>
          </div>

          <div class="form-group">
            <input type="text" [(ngModel)]="newBank.ifsc_code" name="ifsc_code" (ngModelChange)="onIfscChange()" (blur)="verifyIFSC()" required placeholder=" " />
            <label>IFSC Code</label>
            <span class="error" *ngIf="fieldErrors['ifsc_code']">{{fieldErrors['ifsc_code']}}</span>
          </div>

          <div class="form-group">
            <input type="text" [(ngModel)]="newBank.bank_name" name="bank_name" readonly placeholder=" " />
            <label>Bank Name</label>
          </div>
          
          <div class="form-group full">
            <input type="text" [(ngModel)]="newBank.branch" name="branch" readonly placeholder=" " />
            <label>Branch</label>
            <span class="help-text" *ngIf="isVerifyingIfsc">Verifying IFSC...</span>
          </div>
        </div>

        <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

        <div class="modal-footer" style="padding: 16px 0 0; margin-top:20px;">
          <button class="btn secondary" type="button" (click)="cancelAdd()">Cancel</button>
          <button class="btn primary" type="submit" [disabled]="submitting || isVerifyingIfsc || !ifscVerified">
            {{ submitting ? 'Adding...' : 'Add Account' }}
          </button>
        </div>
      </form>
    </div>

  </div>
</div>
  `,
  styles: [`
.modal-backdrop {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(4px); z-index: 1000;
}
.modal {
  position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
  background: white; border-radius: 12px; width: 550px; max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15); z-index: 1001;
  display: flex; flex-direction: column; max-height: 90vh;
}
.modal-header {
  padding: 20px 24px; border-bottom: 1px solid #e2e8f0;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-header h2 { margin: 0; font-size: 1.25rem; font-weight: 600; color: #1e293b; }
.icon-btn { cursor: pointer; color: #64748b; font-size: 1.2rem; }
.icon-btn:hover { color: #0f172a; }
.modal-body { padding: 24px; overflow-y: auto; }
.grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.full { grid-column: span 2; }
.form-group { position: relative; margin-bottom: 8px; }
input, select {
  width: 100%; padding: 12px 16px; border: 1px solid #cbd5e1; border-radius: 8px;
  font-size: 0.95rem; outline: none; transition: all 0.2s; box-sizing: border-box; background: white;
}
input[readonly] { background-color: #f1f5f9; color: #475569; }
input:focus:not([readonly]), select:focus { border-color: #0d9488; box-shadow: 0 0 0 1px #0d9488; }
label {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  background: transparent; padding: 0 4px; color: #64748b; font-size: 0.9rem;
  transition: all 0.2s; pointer-events: none;
}
input:not(:placeholder-shown) ~ label, input:focus ~ label, select ~ label {
  top: 0; font-size: 0.75rem; color: #0d9488; background: white;
}
.error { color: #dc2626; font-size: 0.75rem; position: absolute; bottom: -18px; left: 0; }
.help-text { color: #2563eb; font-size: 0.75rem; position: absolute; bottom: -18px; left: 0; }
.error-msg { background: #fee2e2; color: #dc2626; padding: 10px; border-radius: 6px; font-size: 0.875rem; margin-top: 16px; text-align: center;}
.modal-footer {
  border-top: 1px solid #e2e8f0;
  display: flex; justify-content: flex-end; gap: 12px;
}
.btn { padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight: 500; font-size: 0.9rem; transition: background 0.2s; }
.btn.small { padding: 6px 12px; font-size: 0.8rem; }
.full-width { width: 100%; text-align: center; }
.btn.secondary { background: white; border: 1px solid #cbd5e1; color: #475569; }
.btn.secondary:hover:not(:disabled) { background: #f8fafc; }
.btn.primary { background: #0f172a; border: none; color: white; }
.btn.primary:hover:not(:disabled) { background: #1e293b; }
.btn.danger { background: white; border: 1px solid #ef4444; color: #ef4444; }
.btn.danger:hover:not(:disabled) { background: #fef2f2; }
.btn:disabled { opacity: 0.7; cursor: not-allowed; }

/* Cards */
.empty-state { text-align: center; color: #64748b; padding: 30px; background: #f8fafc; border-radius: 8px; border: 1px dashed #cbd5e1; }
.cards-container { display: flex; flex-direction: column; gap: 16px; }
.bank-card { border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px; background: white; box-shadow: 0 1px 3px rgba(0,0,0,0.05); transition: border 0.2s; }
.bank-card:hover { border-color: #cbd5e1; }
.card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.card-header h3 { margin: 0; font-size: 1rem; color: #0f172a; }
.primary-badge { background: #ecfdf5; color: #059669; padding: 4px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; border: 1px solid #a7f3d0; }
.card-body p { margin: 4px 0; font-size: 0.875rem; color: #334155; }
.card-body strong { color: #64748b; font-weight: 500; min-width: 100px; display: inline-block; }
.card-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px; padding-top: 12px; border-top: 1px solid #f1f5f9; }
.loading-state { text-align: center; padding: 20px; color: #64748b; }
  `]
})
export class BankDetailsModalComponent implements OnInit {
  @Input() distributorId: string = '';
  @Input() distributorName: string = '';
  @Input() existingBankDetails: any[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<any[]>();

  viewMode: 'list' | 'add' = 'list';
  bankAccounts: any[] = [];
  loading = false;

  newBank = {
    bank_account_name: '',
    bank_account_number: '',
    bank_account_type: 'Saving',
    ifsc_code: '',
    bank_name: '',
    branch: ''
  };
  confirm_account_number = '';

  submitting = false;
  isProcessing = false;
  isVerifyingIfsc = false;
  ifscVerified = false;
  
  errorMsg = '';
  fieldErrors: { [key: string]: string } = {};

  constructor(private http: HttpClient) {}

  ngOnInit() {
    if (this.distributorId) {
      this.fetchBankDetails();
    } else {
      this.bankAccounts = Array.isArray(this.existingBankDetails) ? [...this.existingBankDetails] : [];
    }
  }

  fetchBankDetails() {
    this.loading = true;
    this.errorMsg = '';
    this.http.get<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/bank-details`)
      .subscribe({
        next: (res) => {
          this.loading = false;
          if (res.statusCode === 200) {
            this.bankAccounts = res.data || [];
          } else {
            this.errorMsg = res.message || 'Failed to fetch bank details';
          }
        },
        error: (err) => {
          this.loading = false;
          this.errorMsg = err?.error?.message || 'Failed to fetch bank details.';
        }
      });
  }

  setPrimary(bankId: string) {
    this.errorMsg = '';
    this.isProcessing = true;
    this.http.patch<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/bank-details/${bankId}/primary`, {})
      .subscribe({
        next: (res) => {
          this.isProcessing = false;
          if (res.statusCode === 200) {
            // Update local state smoothly
            this.bankAccounts = this.bankAccounts.map(b => ({
              ...b,
              is_primary: b.id === bankId
            }));
            this.saved.emit(this.bankAccounts);
          } else {
            this.errorMsg = res.message || 'Failed to set primary account';
          }
        },
        error: (err) => {
          this.isProcessing = false;
          this.errorMsg = err?.error?.message || 'Failed to set primary account.';
        }
      });
  }

  deleteAccount(bankId: string) {
    if(!confirm("Are you sure you want to delete this bank account?")) return;
    this.errorMsg = '';
    this.isProcessing = true;
    this.http.delete<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/bank-details/${bankId}`)
      .subscribe({
        next: (res) => {
          this.isProcessing = false;
          if (res.statusCode === 200) {
            this.bankAccounts = this.bankAccounts.filter(b => b.id !== bankId);
            this.saved.emit(this.bankAccounts);
          } else {
            this.errorMsg = res.message || 'Failed to delete account';
          }
        },
        error: (err) => {
          this.isProcessing = false;
          this.errorMsg = err?.error?.message || 'Failed to delete account.';
        }
      });
  }

  cancelAdd() {
    this.viewMode = 'list';
    this.errorMsg = '';
    this.fieldErrors = {};
    this.newBank = {
      bank_account_name: '',
      bank_account_number: '',
      bank_account_type: 'Saving',
      ifsc_code: '',
      bank_name: '',
      branch: ''
    };
    this.confirm_account_number = '';
    this.ifscVerified = false;
  }

  onIfscChange() {
    this.ifscVerified = false;
    this.newBank.bank_name = '';
    this.newBank.branch = '';
    this.fieldErrors['ifsc_code'] = '';
  }

  verifyIFSC() {
    const code = this.newBank.ifsc_code?.trim().toUpperCase();
    if (!code) return;
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(code)) {
      this.fieldErrors['ifsc_code'] = 'Invalid IFSC format.';
      this.ifscVerified = false;
      return;
    }

    this.isVerifyingIfsc = true;
    this.fieldErrors['ifsc_code'] = '';
    
    this.http.get<any>(`${environment.apiBaseUrl}/admin/external/ifsc/${code}`).subscribe({
      next: (res) => {
        this.isVerifyingIfsc = false;
        this.ifscVerified = true;
        this.newBank.ifsc_code = code;
        this.newBank.bank_name = res.data.BANK;
        this.newBank.branch = res.data.BRANCH;
      },
      error: (err) => {
        this.isVerifyingIfsc = false;
        this.ifscVerified = false;
        this.newBank.bank_name = '';
        this.newBank.branch = '';
        if (err.status === 404) {
          this.fieldErrors['ifsc_code'] = 'IFSC not found. Please verify the code.';
        } else {
          this.fieldErrors['ifsc_code'] = 'Failed to verify IFSC verification API. Proceed if correct.';
        }
      }
    });
  }

  validate() {
    this.fieldErrors = {};
    if (!this.newBank.bank_account_name) this.fieldErrors['bank_account_name'] = 'Account Name is required.';
    if (!this.newBank.bank_account_number) this.fieldErrors['bank_account_number'] = 'Account Number is required.';
    if (!this.confirm_account_number) {
      this.fieldErrors['confirm_account_number'] = 'Please confirm account number.';
    } else if (this.confirm_account_number !== this.newBank.bank_account_number) {
      this.fieldErrors['confirm_account_number'] = 'Account numbers do not match.';
    }

    if (!this.newBank.ifsc_code) {
      this.fieldErrors['ifsc_code'] = 'IFSC Code is required.';
    } else if (!this.ifscVerified) {
      this.fieldErrors['ifsc_code'] = 'Please verify IFSC code.';
    }

    return Object.keys(this.fieldErrors).length === 0;
  }

  onSubmit() {
    this.errorMsg = '';
    if (!this.validate()) return;
    
    this.submitting = true;
    this.http.post<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/bank-details`, this.newBank)
      .subscribe({
        next: (res) => {
          this.submitting = false;
          if (res.statusCode === 200 || res.statusCode === 201) {
            // Prepend new account locally
            this.bankAccounts.unshift(res.data);
            // If it's the first account, it should be marked as primary locally (handled by backend but we mirror it)
            if (this.bankAccounts.length === 1) {
              this.bankAccounts[0].is_primary = true;
            }
            this.saved.emit(this.bankAccounts);
            this.cancelAdd(); // Go back to list
          } else {
            this.errorMsg = res.message || 'Failed to add bank details';
          }
        },
        error: (err) => {
          this.submitting = false;
          this.errorMsg = err?.error?.message || 'Failed to add bank details.';
        }
      });
  }

  onClose() {
    this.close.emit();
  }
}
